import { render } from "./SavedGraphics.vue?vue&type=template&id=4c49e55a"
import script from "./SavedGraphics.vue?vue&type=script&lang=js"
export * from "./SavedGraphics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__